var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"articleSectionImage"},[_c('div',{style:({'background-image': 'url(' + require('../assets/img/'+_vm.image) + ')'})},[(_vm.caption)?_c('Caption',{attrs:{"title":_vm.caption}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }